import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { selectAppSessionId } from 'store/session/selectors';

import { AppStartUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';

export default function useGetAppStartUavParams() {
    const appSessionId = useSelector(selectAppSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getAppStartUavParams = useCallback(():
        | AppStartUavParams
        | undefined => {
        const baseUavParams = getBaseUavParams(UavEvents.APP_START);

        if (baseUavParams && appSessionId) {
            return {
                ...baseUavParams,
                metadata: {
                    appSessionId,
                    activityDateTime: baseUavParams.timestamp,
                    ...baseUavParams.metadata,
                },
            };
        }

        return undefined;
    }, [getBaseUavParams, appSessionId]);

    return {
        getAppStartUavParams,
    };
}
